import axios from 'axios';
import { Caption, CaptionResponse } from '../types';
import { getApiUrl, API_ENDPOINTS } from '../config/api';


export const downloadVideo = async (captionResponse: CaptionResponse): Promise<string> => {
  console.log("captionResponse.videoPath--> ", captionResponse.videoPath)
  console.log("captionResponse.projectId--> ", captionResponse.projectId)
  
  // Get authentication token
  const token = localStorage.getItem('authToken');
  const headers: Record<string, string> = {
    'Content-Type': 'application/json'
  };
  
  // Add authorization header if token exists
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  const response = await axios.post<string>(
    getApiUrl('/video/downloadVideo'), 
    { ...captionResponse },
    {
      headers
    }
  );
  
  console.log("response-->", response);
  return response.data;
};